import { Button, Grid } from "@aws-amplify/ui-react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import LocalizedStrings from "react-localization";
import { API, graphqlOperation } from "aws-amplify";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

import ItemListCollection from "../ItemListCollection";
import { alertsByCompanyID, listAlerts } from "graphql/queries";
import { LayoutContext } from "layout/context/LayoutContext";

export const AlertsChoose = ({
  initAlertsGranted = [],
  onChangeAlertsGranted,
  resetValues,
}) => {
  const { me } = useContext(LayoutContext);
  const [alertsAvailable, setAlertsAvailable] = useState([]);
  const [alertsGranted, setAlertsGranted] = useState([]);
  const [alertsAvailableSelected, setAlertsAvailableSelected] = useState([]);
  const [alertsGrantedSelected, setAlertsGrantedSelected] = useState([]);
  const [keywordAlertsGranted, setKeywordAlertsGranted] = useState("");

  async function fetchAlertsAvailable(keyword, diffAlerts) {
    try {
      let alertsItems = [];
      if (me.companyID) {
        const alertsData = await API.graphql(
          graphqlOperation(alertsByCompanyID, {
            companyID: me.companyID,
            limit: !keyword ? 50 : undefined,
            filter: keyword
              ? {
                  or: [
                    {
                      name: { contains: keyword },
                    },
                  ],
                }
              : {},
          })
        );
        alertsItems = alertsData.data.alertsByCompanyID.items;
      } else {
        const alertsData = await API.graphql(
          graphqlOperation(listAlerts, {
            limit: !keyword ? 50 : undefined,
            filter: keyword
              ? {
                  or: [
                    {
                      name: { contains: keyword },
                    },
                  ],
                }
              : {},
          })
        );
        alertsItems = alertsData.data.listAlerts.items;
      }
      setAlertsAvailable(
        alertsItems
          ?.filter(
            (alertItem) =>
              !diffAlerts?.some((diffUs) => diffUs.id === alertItem.id)
          )
          ?.map((alertItem) => ({
            id: alertItem.id,
            name: alertItem.name,
          }))
      );
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    setAlertsGranted(initAlertsGranted);
    fetchAlertsAvailable(undefined, initAlertsGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initAlertsGranted, resetValues]);

  useEffect(() => {
    if (onChangeAlertsGranted) onChangeAlertsGranted(alertsGranted);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [alertsGranted]);

  const cleanSelected = () => {
    setAlertsAvailableSelected([]);
    setAlertsGrantedSelected([]);
  };

  const setInAvailable = (items) => {
    setAlertsAvailable((prevSt) => [...prevSt, ...items]);
    setAlertsGranted((prevSt) =>
      prevSt.filter((prev) => !items?.some((alert) => alert.id === prev.id))
    );
    cleanSelected();
  };

  const setInGranted = (items) => {
    setAlertsGranted((prevSt) => [...prevSt, ...items]);
    setAlertsAvailable((prevSt) =>
      prevSt.filter((prev) => !items?.some((alert) => alert.id === prev.id))
    );
    cleanSelected();
  };

  const onSearchAlertsGranted = (keyword) => {
    setKeywordAlertsGranted(keyword);
  };

  return (
    <Grid templateColumns={{ base: "1fr", large: "2fr 1fr 2fr" }} gap="30px">
      <div>
        <div className="fs-5 mb-3">{strings.alerts.available}</div>
        <ItemListCollection
          items={alertsAvailable}
          selectedItems={alertsAvailableSelected}
          setSelectedItems={setAlertsAvailableSelected}
          onSearchSubmit={(keyword) =>
            fetchAlertsAvailable(keyword, alertsGranted)
          }
        />
      </div>
      <div style={styles.containerButtons}>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(alertsGrantedSelected)}
        >
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInAvailable(alertsGranted)}
        >
          <IoIosArrowBack />
          <IoIosArrowBack />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(alertsAvailableSelected)}
        >
          <IoIosArrowForward />
        </Button>
        <Button
          style={styles.buttonActions}
          onClick={() => setInGranted(alertsAvailable)}
        >
          <IoIosArrowForward />
          <IoIosArrowForward />
        </Button>
      </div>
      <div>
        <div className="fs-5 mb-3">{strings.alerts.granted}</div>
        <ItemListCollection
          items={
            keywordAlertsGranted
              ? alertsGranted.filter((alertGr) =>
                  alertGr.name
                    .toLowerCase()
                    .includes(keywordAlertsGranted?.toLowerCase())
                )
              : alertsGranted
          }
          selectedItems={alertsGrantedSelected}
          setSelectedItems={setAlertsGrantedSelected}
          onSearchSubmit={onSearchAlertsGranted}
        />
      </div>
    </Grid>
  );
};

const strings = new LocalizedStrings({
  es: {
    alerts: {
      available: "Alertas disponibles",
      granted: "Alertas asociadas",
    },
    responses: {
      errorFetch: "Error al consultar alertas",
    },
  },
});

const styles = {
  containerButtons: {
    display: "flex",
    justifyContent: "center",
    flexFlow: "column",
    gap: "10px",
  },
  buttonActions: {
    width: "65px",
    alignSelf: "center",
  },
};

export default AlertsChoose;
